import BetaFlags from 'utils/beta_flags.json'
import { propCheck } from 'utils/properties'

export const hasBetaAccess = (user, flag) => {
  let value = BetaFlags[flag]

  if (typeof value === 'boolean') {
    if (!user) {
      return value
    } else if (user.beta_flags && propCheck(user.beta_flags, flag)) {
      return user.beta_flags[flag]
    } else {
      return value
    }
  } else if (typeof value === 'string') {
    if (!user) {
      return false
    }
    // value is the name of a beta flag on User record
    return user.beta_flags && (
      user.beta_flags[value] === '1' ||
      user.beta_flags[value] === 1 ||
      user.beta_flags[value] === 'true' ||
      user.beta_flags[value] === true
    )
  }
}
